const urlName = '/usercenter/v2/t-c/userIdentityX'
export default (API) => ({
	findMyIdentity() {
		return API({
			url: `${urlName}/findMyIdentity`,
		})
	},
})
